import { render } from "./KmmProfileMenu.vue?vue&type=template&id=5403d65b&scoped=true"
import script from "./KmmProfileMenu.vue?vue&type=script&lang=js"
export * from "./KmmProfileMenu.vue?vue&type=script&lang=js"

import "./KmmProfileMenu.vue?vue&type=style&index=0&id=5403d65b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5403d65b"]])

export default __exports__